import {
  UPDATE_FIELD,
  SET_TYPE,
  RESET,
  NEXT,
  PREVIOUS,
  SET_STEP,
} from "./Actions";

const steps = [
  {
    type: "Movie",
    laststep: 5,
    steps: [
      { label: "اطلاعات اولیه", step: 1 },
      { label: "تکمیل اطلاعات", step: 2 },
      { label: "تصاویر و زیرنویس ها", step: 3 },
      { label: "قیمت", step: 4 },
      { label: "پایان و نمایش اطلاعات", step: 5 },
    ],
  },
  {
    type: "Serie",
    laststep: 5,
    steps: [
      { label: "اطلاعات اولیه", step: 1 },
      { label: "تکمیل اطلاعات", step: 2 },
      { label: "فصل ها", step: 3 },
      { label: "تصاویر و تریلر", step: 4 },
      { label: "پایان و نمایش اطلاعات", step: 5 },
    ],
  },
  {
    type: "Music",
    laststep: 5,
    steps: [
      { label: "اطلاعات اولیه", step: 1 },
      { label: "تکمیل اطلاعات", step: 2 },
      { label: "پایان و نمایش اطلاعات", step: 3 },
    ],
  },
  {
    type: "SerieEpisode",
    laststep: 5,
    steps: [
      { label: "اطلاعات اولیه", step: 1 },
      { label: "تکمیل اطلاعات", step: 2 },
      { label: "تصاویر و زیرنویس ها", step: 3 },
      { label: "قیمت", step: 4 },
      { label: "پایان و نمایش اطلاعات", step: 5 },
    ],
  },
  {
    type: "Screening",
    laststep: 5,
    steps: [
      { label: "اطلاعات اولیه", step: 1 },
      { label: "تکمیل اطلاعات", step: 2 },
      { label: "تصاویر و زیرنویس ها", step: 3 },
      { label: "قیمت", step: 4 },
      { label: "پایان و نمایش اطلاعات", step: 5 },
    ],
  },
  {
    type: "CafeScreening",
    laststep: 5,
    steps: [
      { label: "اطلاعات اولیه", step: 1 },
      { label: "تکمیل اطلاعات", step: 2 },
      { label: "تصاویر و زیرنویس ها", step: 3 },
      { label: "قیمت", step: 4 },
      { label: "پایان و نمایش اطلاعات", step: 5 },
    ],
  },
  {
    type: "Physical",
    laststep: 3,
    steps: [
      { label: "اطلاعات اولیه", step: 1 },
      { label: "تکمیل اطلاعات", step: 2 },
      { label: "پایان و نمایش اطلاعات", step: 3 },
    ],
  },
  {
    type: "Download",
    laststep: 3,
    steps: [
      { label: "اطلاعات اولیه", step: 1 },
      { label: "تکمیل اطلاعات", step: 2 },
      { label: "پایان و نمایش اطلاعات", step: 3 },
    ],
  },
];
const defaultState = {
  type: "Movie",
  step: 1,
  steps,
  mode: "add",
  product: null,
  id: null,
  load: false,
  plus_movie: false,
  seasons: [],
  seasonsLoad: [],
};

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [payload.prop]: payload.value,
      };

    case SET_TYPE:
      return {
        ...state,
        type: payload.type,
      };
    case SET_STEP:
      return {
        ...state,
        step: payload.step,
      };
    case PREVIOUS:
      return {
        ...state,
        step: state.step > 1 ? state.step - 1 : 1,
      };
    case NEXT:
      const stpes = state.steps.filter((i) => i.type == state.type)[0];
      const ls = stpes && stpes.laststep;
      return {
        ...state,
        step: state.step < ls ? state.step + 1 : ls,
      };
    case RESET:
      return {
        ...defaultState,
      };
    default:
      return state;
  }
};
